import api, { adminApiPrefix } from './Api';
import {
  PlatformOrderFilter,
  platformOrderFilterToQueryParams,
} from '../interfaces/PlatformOrder/PlatformOrderFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  TrendyolOrder,
  trendyolOrderFromResponse,
} from '../interfaces/Trendyol/TrendyolOrder';

const trendyolAdminApiPrefix = `${adminApiPrefix}/trendyol`;

export const getTrendyolOrders = async (
  filter: PlatformOrderFilter,
): Promise<PaginatedResponse<TrendyolOrder>> => {
  const response = await api.get(`${trendyolAdminApiPrefix}/orders`, {
    params: platformOrderFilterToQueryParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((order: any) =>
      trendyolOrderFromResponse(order),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const checkTrendyolStatus = async (): Promise<void> =>
  api.get(`${trendyolAdminApiPrefix}/status`);
